// ** Router Import
import { Ability } from "@casl/ability"
import Avatar from "@components/avatar"
import { handleModalityUpdate } from '@store/actions/Modalities'
import { isUserLoggedIn } from "@utils"
import axios from "axios"
import React, { Fragment, useContext, useEffect, useState } from "react"
import { Check, X } from "react-feather"
import { useDispatch, useSelector } from "react-redux"
import { Slide, toast } from "react-toastify"
import initialAbility from './configs/acl/ability'
import { modalityOptions, STUDY_STATUS_OPTIONS } from "./configs/const"
import { handleDropDowndataUpdate } from "./redux/actions/dropDowndata"
import Router from './router/Router'
import { socket } from './socket'
import { AbilityContext } from './utility/context/Can'

import ROLES from '@configs/roles'
const ToastContent = ({ message, status }) => (
    <Fragment>
        <div className="toastify-header">
            <div className="title-wrapper">
                <Avatar size="sm" color={status ? "success" : "danger"} icon={status ? <Check size={12} /> : <X size={12} />} />
                <h6 className="toast-title font-weight-bold">
                    {status ? "Success" : "Failed"}
                </h6>
            </div>
        </div>
        <div className="toastify-body">
            <span>
                {message}
            </span>
        </div>
    </Fragment>
)

const App = props => {
    const loginState = useSelector((state) => state.auth)
    const [userData, setUserData] = useState(() => JSON.parse(isUserLoggedIn()))
    const ability = useContext(AbilityContext)
    const [mainAbility, setMainAbility] = React.useState(initialAbility)
    const userDataRedux = useSelector((state) => state.auth.userData)
    useEffect(() => {
        setUserData(userDataRedux)
    }, [userDataRedux])
    useEffect(() => {

        function onCompletedPatientEditProcessEvent(value) {

            const d = JSON.parse(value)
            if (d.status) {
                toast.success(
                    <ToastContent
                        message={d.message}
                        status={d.status}
                    />,
                    {
                        transition: Slide,
                        hideProgressBar: true,
                        autoClose: 4000
                    }
                )
            } else {
                toast.error(
                    <ToastContent
                        message={d.message}
                        status={d.status}
                    />,
                    {
                        transition: Slide,
                        hideProgressBar: true,
                        autoClose: 4000
                    }
                )
            }

        }
        console.log(`updateAdvanceFilter_${userData?.parentUser ? userData?.parentUser : userData?._id}`)

        const updateAdvanceFilter = ({ advanceFilter }) => {
            const access = userData?.access
            if (advanceFilter === userData?.advanceFilter) { return }
            if (advanceFilter === 1) {
                if (!access.find(a => a.action === "manage" && a.subject === "filter-listings")) {
                    access.push({ action: "manage", subject: "filter-listings" })
                }

                if (userData.role === ROLES.ClinicUser && access.find(a => a.action === "manage" && a.subject === "filter-listings")) {
                    access.splice(access.findIndex(a => a.action === "manage" && a.subject === "filter-listings"), 1)
                }
                userData.access = access
                userData.advanceFilter = advanceFilter
                localStorage.setItem("userData", JSON.stringify(userData))
                setMainAbility(new Ability([...userData.access]))
                setUserData(userData)

            } else {

                if (access.find(a => a.action === "manage" && a.subject === "filter-listings")) {
                    access.splice(access.findIndex(a => a.action === "manage" && a.subject === "filter-listings"), 1)
                }
                userData.access = access
                userData.advanceFilter = advanceFilter
                localStorage.setItem("userData", JSON.stringify(userData))
                setMainAbility(new Ability([...userData.access]))
                setUserData(userData)

            }
        }
        socket.on(`updateAdvanceFilter_${userData?.parentUser ? userData?.parentUser : userData?._id}`, updateAdvanceFilter)
        socket.on(`completedPatientEditProcess_${userData?._id}`, onCompletedPatientEditProcessEvent)

        return () => {
            socket.off(`completedPatientEditProcess_${userData?._id}`, onCompletedPatientEditProcessEvent)
            socket.off(`updateAdvanceFilter_${userData?.parentUser ? userData?.parentUser : userData?._id}`, updateAdvanceFilter)

        }
    }, [userData?._id])
    const dispatch = useDispatch()
    const LicenseData = useSelector((state) => state.license)
    useEffect(async () => {
        if (userDataRedux?._id) {
            try {

                const filterData = await axios.get(
                    `${process.env.REACT_APP_API_URL}/filter-module/get/${userDataRedux?._id}`,
                    {

                    })
                // const filterDropDownData = []
                // console.log(filterData, "firstData")
                // Object.values(filterData.data.filters).forEach((item)=>{
                //   filterDropDownData.push({value:item._id, label:item.name, modality:item.modality})
                // })
                // console.log(filterDropDownData, "filterDropDownData")
                // setFilterDropDownData(filterDropDownData)
                dispatch(handleDropDowndataUpdate({ clinicNames: Object.values(filterData.data.clinicNames), Physicians: Object.values(filterData.data.Physicians), studyStatus: Object.values(filterData.data.studyStatus).length > 0 ? Object.values(filterData.data.studyStatus) : STUDY_STATUS_OPTIONS }))
                // dispatch(handleModalityUpdate(Object.values(filterData.data.modality).length > 0 ? Object.values(filterData.data.modality) : modalityOptions))
                dispatch(handleModalityUpdate(modalityOptions))
                //   setModalityOptionsForFilters(Object.values(filterData.data.modality).length > 0 ? Object.values(filterData.data.modality) : modalityOptions)

            } catch (error) {
                console.log(error, "error")
            }


        } else {
            dispatch(handleModalityUpdate(modalityOptions))
        }

    }, [userDataRedux?._id])

    // useEffect(async () => {
    //     if (!userDataRedux?._id) return
    //     try {

    //         const latestLicenseData = await axios.get(
    //           `${process.env.REACT_APP_API_URL}/user/license/latest/`,
    //           {

    //           })
    //           // const filterDropDownData = []
    //           // console.log(filterData, "firstData")
    //           // Object.values(filterData.data.filters).forEach((item)=>{
    //           //   filterDropDownData.push({value:item._id, label:item.name, modality:item.modality})
    //           // })
    //           // console.log(filterDropDownData, "filterDropDownData")
    //           // setFilterDropDownData(filterDropDownData)
    //           if (latestLicenseData.data.success) {
    //             if (latestLicenseData.data.data.advanceFilter === 0) {
    //                     const access = userDataRedux.access
    //                     const data = access.filter((item) => {
    //                         return item.subject !== "filter-listings"
    //                       })
    //                       can.update(data)
    //                     //   can.removeAbility("filter-listings", "manage")
    //                     // console.log("accesssss", data)
    //                     // console.log("removed filter listing manage permission")
    //                     // can.removeAbility("filter-listings", "manage")
    //                 } else {
    //                     // console.log("added filter listing manage permission")
    //                     // can.removeAbility("filter-listings", "manage")
    //                 }
    //             // can.removeAbility("filter-listings", "manage")
    //             dispatch(handleuserDataUpdate(latestLicenseData.data.data))
    //              dispatch(handleLicenseUpdate(latestLicenseData.data.data))
    //           }
    //         //   setModalityOptionsForFilters(Object.values(filterData.data.modality).length > 0 ? Object.values(filterData.data.modality) : modalityOptions)

    //     } catch (error) {
    //       console.log(error, "error")
    //     }
    // }, [userDataRedux?._id])

    useEffect(() => {
        if (loginState?.accessToken || (userData)) {
            socket.connect()
        } else {
            socket.disconnect()
        }
    }, [loginState])

    // if (userDataRedux?._id) {
    return <AbilityContext.Provider value={mainAbility} >
        <Router />
    </AbilityContext.Provider>
    // }
    // return <Router />
}

export default App
